import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../../store";
import {
  Button,
  Table,
  TableTR,
  Filter,
  FilterValue,
  toast,
} from "../../../components";
import { Avatar } from "@/utils/ui/Avatar/Avatar";
import { formatEntityName } from "@/utils/utilFunctions/entityName";
import AddProductForm from "@/components/Product/AddProductForm";
import {
  getListProduct,
  getProduct,
  archiveProduct,
} from "@/store/constants/constants.action";

import {
  setCurrentProduct,
  setProductList,
} from "@/store/constants/constants.slice";
import { useAppDispatch } from "../../../store";
import { formatTimestampToAgo } from "../../../utils";
import PageHeader from "@/components/Layout/PageHeader";
import { Option } from "@/database";
import Modal from "@/components/Modal/Modal";
import { Edit } from "lucide-react";
import { NoContentFound } from "@/utils/ui/NoContent";

import { getListUser } from "@/store/user/user.action";

const headers: { name: string; width: string }[] = [
  { name: "Name", width: "31%" },
  { name: "Code", width: "15%" },
  { name: "Business", width: "15%" },
  { name: "Created On", width: "15%" },
  { name: "Status", width: "12%" },
  { name: "Action", width: "12%" },
];

const ProductList = ({
  productList,
  getListProduct,
  setCurrentProduct,
  setProductList,
  isClearFilter,
  category,
  loading,
  count,
  bunchProductList,
  bunchBusinessList,
  getProduct,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [formState, setFormState] = useState<{
    isDirty: boolean;
    isValid: boolean;
    isLoading: { error: boolean; success: boolean; loading: boolean };
  }>({
    isDirty: false,
    isValid: false,
    isLoading: { error: false, success: false, loading: false },
  });
  const [filters, setFilters] = useState<Record<string, FilterValue>>({});
  const [availableFilters, setAvailableFilters] = useState<Filter[]>([]);
  const [archivingId, setArchivingId] = useState<number | null>(null);
  const dispatch = useAppDispatch();

  const handlesetfilter = (filter: any) => {
    setFilters(filter);
  };

  const handleModalOpen = () => {
    dispatch(setCurrentProduct(null));
    setSelectedProduct(null);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  useEffect(() => {
    setProductList({
      data: { list: [], count: 0, isLoading: true, error: "" },
    });
  }, [setProductList]);

  const handleArchiveToggle = async (item: any) => {
    if (archivingId === item.id) return;
    setArchivingId(item.id);
    const newArchive = item.archive === 1 ? 0 : 1;
    dispatch(
      archiveProduct(
        { id: item.id, archive: newArchive },
        () => {
          toast.success(
            newArchive === 1
              ? "Team marked as Inactive"
              : "Team marked as Active"
          );
          setArchivingId(null);
        },
        () => setArchivingId(null)
      )
    );
  };

  const handleEdit = async (product: any) => {
    // dispatch(setCurrentProduct(product));
    const result = await getProduct({ id: product.id });
    if (result.success) {
      setSelectedProduct(result.data);
      setIsModalOpen(true);
    } else {
      toast.fail(result.error || "Failed to get product");
    }
  };

  useEffect(() => {
    if (
      bunchProductList.length === 0 ||
      bunchBusinessList.length === 0 ||
      availableFilters.length > 0
    )
      return;
    if (bunchProductList.length > 0 && bunchBusinessList.length > 0) {
      const productListOptionArray: Option[] = bunchProductList.map(
        (values: any) => ({
          label: formatEntityName(values),
          value: values?.id,
          displayValue: formatEntityName(values),
          baseURL: values?.baseurl,
          logo: values?.logo,
        })
      );

      setAvailableFilters([
        {
          displayName: "Status",
          name: "status",
          type: "radio",
          suffix: ":",
          options: [
            { label: "Active", value: "1", displayValue: "Active" },
            { label: "Inactive", value: "2", displayValue: "Inactive" },
          ],
        },
        {
          displayName: "Keyword",
          name: "name",
          type: "text",
          suffix: "contains",
        },
        {
          displayName: "Name",
          name: "id",
          type: "multiselect",
          suffix: "contains",
          options: productListOptionArray,
        },

        {
          displayName: "Business",
          name: "business",
          type: "multiselect",
          suffix: ":",
          options: bunchBusinessList.map((business: any) => ({
            label: formatEntityName(business),
            value: business?.id,
            displayValue: formatEntityName(business),
            baseURL: business?.baseurl,
            logo: business?.logo,
          })),
        },
      ]);
    }
  }, [bunchProductList, bunchBusinessList]);

  const businessMap = bunchBusinessList?.reduce(
    (acc: Record<string, string>, org: any) => {
      acc[org?.id] = formatEntityName(org);
      return acc;
    },
    {}
  );

  const handleSaveProduct = (e: any) => {
    e.preventDefault();
    const event = new Event("submit", {
      bubbles: true,
      cancelable: true,
    });
    window.dispatchEvent(event);
  };

  return (
    <div className="container">
      <PageHeader
        title="Teams"
        buttonText="ADD NEW"
        onButtonClick={handleModalOpen}
        backPath="/setting"
      />
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          title={
            selectedProduct
              ? `Edit Team: ${formatEntityName(selectedProduct)}`
              : "Add New Team"
          }
          width="80vw"
          footer={
            <div className="d-flex justify-content-end w-100">
              <Button type="light" onClick={handleModalClose} className="me-2">
                Cancel
              </Button>
              <Button
                type="primary"
                isDisabled={
                  !formState.isDirty ||
                  //  || !formState.isValid
                  formState.isLoading.loading
                }
                onClick={(e: any) => handleSaveProduct(e)}
              >
                Save
              </Button>
            </div>
          }
        >
          <AddProductForm
            onClose={handleModalClose}
            onFormStateChange={setFormState}
            category={category}
          />
        </Modal>
      )}{" "}
      <Table
        columns={headers}
        isLoading={loading}
        totalCount={count}
        // onFilterChange={handleFilterChange}
        appliedFilters={filters}
        availableFilters={availableFilters}
        handleSetFilters={handlesetfilter}
        isFilter={true}
        getListMedia={getListProduct}
        isSetinParams={false}
        filters={filters}
        isClearFilter={isClearFilter}
        apiCallDelayTimer={0}
      >
        {productList.length > 0 ? (
          [...productList]
            .sort((a: any, b: any) => {
              const keyword =
                typeof filters?.name === "string"
                  ? filters.name.trim().toLowerCase()
                  : "";
              if (!keyword) return 0;
              const aName = (a.name || "").toLowerCase();
              const bName = (b.name || "").toLowerCase();
              const score = (n: string) =>
                n === keyword
                  ? 0
                  : n.startsWith(keyword)
                    ? 1
                    : n.includes(keyword)
                      ? 2
                      : 3;
              return score(aName) - score(bName);
            })
            .map((item: any) => (
              <TableTR key={item.id} rowKey={item.id}>
                <td valign="middle">
                  <div
                    className="d-flex align-items-center gap-2 bi"
                    onClick={() => handleEdit(item)}
                  >
                    <Avatar
                      text={item.name}
                      size={28}
                      logo={item?.logo}
                      baseURL={item?.baseurl}
                    />
                    <span className="bi">{formatEntityName(item)}</span>
                  </div>
                </td>
                <td valign="middle">{item.code}</td>
                <td valign="middle">{businessMap[item.business]}</td>
                <td valign="middle">{formatTimestampToAgo(item?.ct)}</td>
                <td valign="middle">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      opacity: archivingId === item.id ? 0.5 : 1,
                      cursor: archivingId === item.id ? "wait" : "pointer",
                    }}
                    onClick={() => handleArchiveToggle(item)}
                  >
                    <div
                      style={{
                        width: 36,
                        height: 20,
                        borderRadius: 10,
                        background: item.archive === 1 ? "#ccc" : "#2563eb",
                        position: "relative",
                        transition: "background 0.2s",
                        flexShrink: 0,
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: 3,
                          left: item.archive === 1 ? 3 : 19,
                          width: 14,
                          height: 14,
                          borderRadius: "50%",
                          background: "#fff",
                          transition: "left 0.2s",
                        }}
                      />
                    </div>
                    <span
                      style={{
                        fontSize: 13,
                        color: item.archive === 1 ? "#888" : "#2563eb",
                        fontWeight: 500,
                      }}
                    >
                      {item.archive === 1 ? "Inactive" : "Active"}
                    </span>
                  </div>
                </td>
                <td style={{ textAlign: "center" }}>
                  <div
                    className="d-flex align-items-center gap-2"
                    role="button"
                    onClick={() => handleEdit(item)}
                  >
                    <span className="btn btn-outline-secondary" title="Edit">
                      <Edit size={16} />
                    </span>
                  </div>
                </td>
              </TableTR>
            ))
        ) : (
          <TableTR rowKey="no-content">
            <td colSpan={headers.length}>
              <NoContentFound message="No Product Found" fill />
            </td>
          </TableTR>
        )}
      </Table>
    </div>
  );
};

const mapState = (state: RootState) => ({
  productList: state.constants.productList.list,
  count: state.constants.productList.count,
  businessList: state.constants.businessList.list,
  loading: state.constants.productList.isLoading,
  userList: state.users.userList.list,
  currentProduct: state.constants.currentProduct,
  isFilter: state.media.isFilter,
  isClearFilter: state.media.isClearFilter,
  category: state.app.category,
  bunchProductList: state.constants.bunchProductList.list,
  bunchBusinessList: state.constants.bunchBusinessList.list,
});

const mapDispatch = {
  getListProduct,
  setCurrentProduct,
  setProductList,
  getListUser,
  getProduct,
  archiveProduct,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;
export default connector(ProductList);
